import type { Analytics } from "firebase/analytics";
import { logEvent } from "firebase/analytics";
import { trackAdsLead, trackAdsPurchase } from "./googleAdsTracking";

type PurchaseTier = "high" | "mid" | "low";
type AuthProvider = "email_password" | "google";

export function purchaseTransactionIdFromSession(sessionId: string) {
  return sessionId.trim();
}

function itemNameForTier(tier: PurchaseTier): string {
  if (tier === "high") return "Begin Full Build Engagement";
  if (tier === "mid") return "Start Guided Build";
  return "Technical Starter Kit";
}

export function emitCheckoutBeginTracking(
  analytics: Analytics | undefined,
  payload: {
    proposalId: string;
    tier: PurchaseTier;
    amount: number;
  }
) {
  if (!analytics) return;
  logEvent(analytics, "devplan_checkout_start", {
    proposalId: payload.proposalId,
    tier: payload.tier,
    amount: payload.amount,
  });
  logEvent(analytics, "begin_checkout", {
    currency: "USD",
    value: payload.amount,
    items: [
      {
        item_id: `devplan_${payload.tier}`,
        item_name: itemNameForTier(payload.tier),
        quantity: 1,
        price: payload.amount,
      },
    ],
  });
}

export function emitPurchaseTracking(
  analytics: Analytics | undefined,
  payload: {
    proposalId: string;
    tier: PurchaseTier;
    transactionId: string;
    amount: number;
  }
) {
  // Google Ads Purchase conversions are only for confirmed Stripe payments on High + Mid tiers.
  if (payload.tier !== "high" && payload.tier !== "mid") return;

  if (analytics) {
    logEvent(analytics, "devplan_checkout_confirmed", {
      proposalId: payload.proposalId,
      tier: payload.tier,
      transactionId: payload.transactionId,
    });
    logEvent(analytics, "purchase", {
      transaction_id: payload.transactionId,
      currency: "USD",
      value: payload.amount,
      items: [
        {
          item_id: `devplan_${payload.tier}`,
          item_name: itemNameForTier(payload.tier),
          quantity: 1,
          price: payload.amount,
        },
      ],
    });
  }
  trackAdsPurchase({
    transactionId: payload.transactionId,
    value: payload.amount,
    currency: "USD",
  });
}

export function emitSignupLeadTracking(
  analytics: Analytics | undefined,
  payload: {
    proposalId: string;
    authProvider: AuthProvider;
  }
) {
  // Google Ads Lead conversion is only for Low-tier free signup + download unlock success.
  trackAdsLead({ dedupeKey: payload.proposalId });

  if (analytics) {
    logEvent(analytics, "devplan_free_download_claimed", {
      proposalId: payload.proposalId,
      authProvider: payload.authProvider,
    });
    logEvent(analytics, "generate_lead", {
      currency: "USD",
      value: 0,
      method: payload.authProvider,
    });
  }
}
